import {Component, OnInit} from '@angular/core';
import {TerminaisNacionaisService} from "./terminais-nacionais.service";
import {TerminaisNacionaisModel} from "./terminais-nacionais.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";

declare let swal: any;

@Component({
  selector: 'app-terminais',
  templateUrl: './terminais-nacionais.component.html'
})
export class TerminaisNacionaisComponent extends Components implements OnInit {

  terminais: TerminaisNacionaisModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    private terminaisService: TerminaisNacionaisService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        const p = data.privilegios[i];
        const acaoUrl = (p.acao && p.acao[0] && p.acao[0].url) ? p.acao[0].url : '';
        const idAcao = String(p.id_acao || '');

        if(idAcao === '20' || acaoUrl == 'terminais' || acaoUrl == 'terminais-nacionais' || acaoUrl == 'prestacao-mapa' || acaoUrl == 'mercado-interno'){
          this.privilegioUsuario.consultar = p.consultar;
          this.privilegioUsuario.editar = p.editar;
        }
      }
      if(this.func.userIsMaster()){
        this.privilegioUsuario.consultar = true;
        this.privilegioUsuario.editar = true;
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    /*this.terminaisService.getPaginacao(1, this.itensPorPagina, ['pais'])
      .subscribe(data => {
        this.terminais = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.terminais);
        }
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });*/

    this.getPage(1);


  }

  delete(terminal) {
    let terminais = this.terminais;
    let terminaisService = this.terminaisService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarTerminal')+terminal.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(self.global.debug == true){
          console.log(terminais);
        }

        let index = terminais.indexOf(terminal);
        terminais.splice(index, 1);

        terminaisService.apagar(terminal.id_terminal)
          .subscribe(res => {
              //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
              self.terminais = terminais;
            },
            err => {
              // Revert the view back to its original state
              terminais.splice(index, 0, terminal);
              self.terminais = terminais;

              self.func.showErro(err.json());
            });

      });

  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.terminaisService.getPaginacao(pagina, this.itensPorPagina)
      .subscribe(data => {
        this.terminais = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/terminais-nacionais/terminais-nacionais.component.ts